import { graphql } from 'gatsby'
import { normalizedData } from '@utils'
import Layout from '@layout'
import Header from '@layout/header/layout-01'
import Footer from '@layout/footer/layout-01'
import PageHeader from '@containers/page-header/layout-04'
import BSWForumArea from '@containers/bsw-veranstaltung/layout-01'
import BSWForumProgramArea from '@containers/bsw-forum/layout-01'

const BSWForumPage = ({ location, data }) => {
  const content = normalizedData(data?.strapiPage?.content || [])

  return (
    <Layout location={location}>
      <Header />
      <main className="site-wrapper-reveal">
        <PageHeader
          data={{
            ...content['header-section']
          }}
        />
        <BSWForumArea
          data={{
            ...content['veranstaltung-section']
          }}
          bg="white"
        />
        <BSWForumProgramArea
          data={{
            ...content['program-section']
          }}
          data2={{
            ...content['anmeldung-section']
          }}
          dataSlider={{
            ...content['slider-section']
          }}
          bg="rgb(178,201,211)"
        />
      </main>
      <Footer />
    </Layout>
  )
}

export { Head } from '@components/head'

export const query = graphql`
  query BSWForumPageQuery($title: String, $locale: String) {
    strapiPage(
      title: { eq: $title }
      pageType: { eq: "innerpage" }
      locale: { eq: $locale }
    ) {
      content {
        ...StrapiPageContent
      }
      seo {
        ...StrapiPageSEO
      }
    }
  }
`

export default BSWForumPage
